import { createSelector } from 'reselect';
 
const selectChannel = (state: any) => state.channel;
 
export const selectCurrentItem = createSelector([selectChannel], (channel) => channel.current);
 
export const selectListItems = createSelector([selectChannel], (channel) => channel.list);
 
 
export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectCreatedItem = createSelector([selectChannel], (channel) => channel.create);
 
export const selectUpdatedItem = createSelector([selectChannel], (channel) => channel.update);
 
export const selectReadItem = createSelector([selectChannel], (channel) => channel.read);
 
export const selectDeletedItem = createSelector([selectChannel], (channel) => channel.delete);
 
export const selectSearchedItems = createSelector([selectChannel], (channel) => channel.search);
 
export const selectItemsCount = createSelector([selectChannel], (channel) => channel.count);
 
export const selectItemsFilter = createSelector([selectChannel], (channel) => channel.filter);